import { useQuery } from '@tanstack/react-query';

import { IntentService } from 'src/utils/api';

interface PaginationOptions {
  page?: number;
  page_size?: number;
  analysis_type?: string;
  sort_by?: string;
  sort_order?: string;
}

export const getIntents = async ({
  page = 1,
  page_size = 10,
  analysis_type,
  sort_by = 'created_at',
  sort_order = 'desc',
}: PaginationOptions = {}) => {
  const response = await IntentService.getIntents({
    page,
    page_size,
    analysis_type,
    sort_by,
    sort_order: sort_order === 'asc' ? 'asc' : 'desc',
  });
  return response;
};

export function useIntents(paginationOptions: PaginationOptions) {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['intents', paginationOptions],
    queryFn: () => getIntents(paginationOptions),
  });

  return {
    data,
    isLoading,
    refetch,
  };
}
